<template>
    <p class="smallgrayroundedbox">Sale Ends in <span class="red"><span id="countdownToMidnight"></span></span>
               </p>
</template>


<script>
    export default {
        mounted() {
            setInterval(this.ShowTimes, 1000);
            this.registerDomcontent();
        },
        methods: {
            ShowTimes() {
                var now = new Date();
                var hrs = 23 - now.getHours();
                var mins = 59 - now.getMinutes();
                var secs = 59 - now.getSeconds();
                var str = '';
                str = '<b>' + hrs + ' hrs ' + mins + ' mins ' + secs + ' secs </b>';
                document.getElementById('countdownToMidnight').innerHTML = str;
            },
            registerDomcontent() {
              document.addEventListener("DOMContentLoaded", function(event) {
                 var radioContainer1 = document.getElementsByClassName("radioContainer1");
                 for (let i = 0; i < radioContainer1.length; i ++) {
                    let chs = radioContainer1[i].querySelectorAll("input:checked");
                    if (chs.length < 1) {
                       chs = radioContainer1[i].querySelectorAll("input");
                       if (chs.length > 0) {
                          chs[0].checked = true;
                       }
                    }
                 }


                 var oldprice = document.getElementsByClassName("txtOldPrice")[0].textContent;
                 oldprice = oldprice.replace('$','');
                 var saleprice = document.getElementsByClassName("SalePrice")[0].textContent;
                 saleprice = saleprice.replace('Sale: $','');
                 var savings = oldprice - saleprice;
                 document.getElementById('savings').textContent = savings.toFixed(2);

                 var oldprice2 = document.getElementsByClassName("txtOldPrice")[1].textContent;
                 oldprice2 = oldprice2.replace('$','');
                 var saleprice2 = document.getElementsByClassName("SalePrice")[1].textContent;
                 saleprice2 = saleprice2.replace('Sale: $','');
                 var savings2 = oldprice2 - saleprice2;
                 document.getElementById('savings2').textContent = savings2.toFixed(2);


                 let radios = document.querySelectorAll('input[name="radio_engine_type"]');
                 for (let i = 0; i < radios.length; i ++) {

                    // Note: There's no such function
                    //radios[i].removeEventListener('change', radioEventListener);
                    radios[i].onchange = function() {
                       var origin_title = document.getElementById('prod_title').textContent;
                       var searchKey = "Diesel";
                       var replaceKey = "Diesel";
                       if (this.value == "diesel") {
                          document.querySelectorAll('input[name="add"]')[0].value = document.querySelectorAll('input[name="add_diesel"]')[0].value;
                          document.getElementById('preview').src = "https://carcomputerexchange.com/images/uploads/3.jpg";
                          origin_title = origin_title.replace("Gasoline", "Diesel");
                          searchKey = "Gasoline";
                       } else if (this.value == "gasoline") {
                          document.querySelectorAll('input[name="add"]')[0].value = document.querySelectorAll('input[name="add_gasoline"]')[0].value;
                          document.getElementById('preview').src = "https://carcomputerexchange.com/images/uploads/4.jpg";
                          origin_title = origin_title.replace("Diesel", "Gasoline");
                          replaceKey = "Gasoline";
                       }
                       var crtitle = document.getElementById('prod_title_mobile').innerHTML; /* h1 change */
                       document.getElementById('prod_title_mobile').innerHTML = crtitle.replace(searchKey, replaceKey);
                       document.getElementById('prod_title').textContent = origin_title; /* h1 change */
                       document.getElementById('preview').alt = origin_title; /* image alt */
                       document.getElementById('preview').title = origin_title; /* image title */
                       document.getElementsByTagName('title')[0].textContent = origin_title; /* title element */
                       var spans = document.getElementsByTagName("span"); /* breadcrumb */
                       for (var i = 0; i < spans.length; i++) {
                          if (spans[i].textContent.includes(searchKey)) {
                             spans[i].textContent = spans[i].textContent.replace(searchKey, replaceKey);
                          }
                       }
                       var lis = document.getElementsByTagName("li"); /* li */
                       for (var i = 0; i < lis.length; i++) {
                          if (lis[i].textContent.includes(searchKey)) {
                             lis[i].textContent = lis[i].textContent.replace(searchKey, replaceKey);
                          }
                       }
                    }
                 }


                 // Note: It's not defined
                 fbq('track', 'ViewContent', {
                    value: '895.00',
                    currency: 'USD',
                    content_type: 'product',
                    content_ids: '199J17'
                 })

              });
            }
        }
    }
</script>